export default __webpack_public_path__ + "static/media/012-line-purple.c1f4946f.svg";